import React from 'react';
import ContactForm from '../components/ContactForm';
import PageHero from '../components/PageHero';
import { useLanguage } from '../contexts/LanguageContext';
import { useMobileMenu } from '../components/Footer';

const ContactPage: React.FC = () => {
  const { t, language } = useLanguage();
  const { closeMobileMenu } = useMobileMenu();

  return (
    <div className="bg-gray-50">
      <PageHero 
        title={t('nav.contact')} 
        subtitle={language === 'en' 
          ? 'Let\'s discuss how YouCRM can transform your business processes'
          : 'Beszéljük meg, hogyan alakíthatja át a YouCRM az üzleti folyamatait'
        } 
      />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-24 pt-12">
        <div className="bg-white rounded-xl shadow-xl overflow-hidden">
          {/* Contact details bar */}
          <div className="flex flex-wrap justify-center gap-8 py-6 px-6 bg-gradient-to-r from-indigo-50 to-purple-50 border-b border-gray-100">
            <div className="flex items-center">
              <div className="flex-shrink-0 bg-gradient-to-r from-indigo-500 to-purple-600 p-2 rounded-full">
                <svg className="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-500">
                  {language === 'en' ? 'Phone' : 'Telefon'}
                </p>
                <p className="text-md font-semibold text-gray-700">+36709083086</p>
              </div>
            </div>

            <div className="flex items-center">
              <div className="flex-shrink-0 bg-gradient-to-r from-indigo-500 to-purple-600 p-2 rounded-full">
                <svg className="h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
              </div>
              <div className="ml-3">
                <p className="text-sm font-medium text-gray-500">
                  {language === 'en' ? 'Email' : 'E-mail'}
                </p>
                <p className="text-md font-semibold text-gray-700">info@webforyou.hu</p>
              </div>
            </div>
          </div>
          
          {/* Form section */}
          <div className="p-8 sm:p-10">
            <ContactForm />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactPage; 